// extracted by mini-css-extract-plugin
export var card = "_mz-0";
export var content = "_mz-2";
export var details = "_mz-3";
export var icon = "_mz-1";
export var iconBlue = "_mz-5";
export var iconBrand = "_mz-4";
export var iconGrayBlue = "_mz-6";
export var iconGreen = "_mz-7";
export var iconIndigo = "_mz-8";
export var iconOrange = "_mz-9";
export var iconPurple = "_mz-a";
export var iconRed = "_mz-b";
export var iconWarning = "_mz-c";